<template>
  <div>
    <span class="summarize-news-btn mr-1" @click="routeToSummarizeNewsModal">
        View news summary
    </span>
  </div>
</template>

<script>
import SummarizeNewsModal from "../modals/SummarizeNewsModal";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import { mapGetters } from "vuex";
import * as CONSTANTS from "@/store/constants";

export default {
  name: "summarize-news-button",
  mixins: [HomebaseMixpanelMixin],
  components: {
    SummarizeNewsModal
  },
  computed: {
    ...mapGetters(["user"]),
  },

  created() {
    if (this.$route.path === CONSTANTS.NEWS_SUMMARY_PATH) this.launchSummarizeNewsModal();
  },

  methods: {

    routeToSummarizeNewsModal() {
        this.trackGenerateViewNewsSummaryClicked();
        this.$router.push(CONSTANTS.NEWS_SUMMARY_PATH);
    },

    launchSummarizeNewsModal() {

      this.$modal.show(
        SummarizeNewsModal,
        {},
        {
          adaptive: true,
          scrollable: true,
          width: 900,
          height: "auto",
        },
        {
          'closed': () => {
              this.$router.push("/");
          },
        }
      );
    },
  },
};
</script>

<style scoped>
.summarize-news-btn {
  font-family: artifaktElementBold;
  font-size: 16px;
  color: var(--secondary-color);
  text-decoration: underline;
}
.summarize-news-btn:hover {
  cursor: pointer;
  color: var(--secondary-color);
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/buttons/SummarizeNewsButton.vue